import React, { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { MuiOtpInput } from "mui-one-time-password-input";
import { Box, Button, CircularProgress, Paper, Typography } from "@mui/material";
import { MdClose } from "react-icons/md";
import { getCurrentUserInfo } from "../../utils/UserAuth";

const PinComponent = ({ onClose, isLoading, onDeductFunds }) => {
	const navigate = useNavigate();
	const accessPin = getCurrentUserInfo()?.accessPin;

	const [otp, setOtp] = useState("");

	const handleChange = (newValue) => {
		setOtp(newValue);
	};

	function matchIsNumeric(text) {
		const isNumber = typeof text === "number";
		const isString = typeof text === "string";
		return (isNumber || (isString && text !== "")) && !isNaN(Number(text));
	}

	const validateChar = (value) => {
		return matchIsNumeric(value);
	};

	const handleComplete = () => {
		if (otp.length < 4) {
			return false;
		}
		if (otp !== accessPin) {
			return true;
		} else {
			return false;
		}
	};

	const navigateToProfile = () => {
		onClose();
		navigate("/profile", { state: { context: "pin" } });
	};

	return (
		<Paper
			sx={{
				width: "350px",
				paddingX: 4,
				paddingY: 3,
				borderRadius: "12px",
				display: "flex",
				flexDirection: "column",
				gap: 1,
			}}>
			<Box display='flex' justifyContent='flex-end'>
				<button onClick={onClose}>
					<MdClose size={24} />
				</button>
			</Box>
			<Typography variant='h6' component='p'>
				Enter Your Pin
			</Typography>
			<Box display='flex' flexDirection='column' gap={1}>
				<MuiOtpInput
					value={otp}
					onChange={handleChange}
					validateChar={validateChar}
					onComplete={handleComplete}
					TextFieldsProps={{ disabled: isLoading }}
				/>
				{handleComplete() && (
					<Typography component='p' variant='body' color='red'>
						Invalid transaction pin.
					</Typography>
				)}
			</Box>
			<Button
				variant='contained'
				color='primary'
				sx={{ marginTop: 1 }}
				disabled={otp.length < 4 || otp !== accessPin || isLoading}
				onClick={onDeductFunds}>
				{isLoading ? <CircularProgress color='primary' size={30} thickness={5} /> : "proceed"}
			</Button>
			<Box display='flex' justifyContent='center' marginTop={0}>
				<Button variant='text' disabled={isLoading} onClick={navigateToProfile}>
					{accessPin ? "edit" : "create"} transaction pin
				</Button>
			</Box>
		</Paper>
	);
};

export default PinComponent;

PinComponent.propTypes = {
	onClose: PropTypes.func,
	onDeductFunds: PropTypes.func,
	isLoading: PropTypes.bool,
};
